import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Avatar, Fade, Button, IconButton, FormControl, Paper, Slide, Typography,
  withStyles, InputLabel, Select, MenuItem, TextField } from '@material-ui/core';
import LongMenu from '../share/LongMenu';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { parse, format, subMonths } from 'date-fns';
import Search from '@material-ui/icons/Search';
import { inject, observer } from 'mobx-react';
import FilterBeneficiario from '../share/FilterBeneficiario';
import AcertoMensalidadeService from '../../services/AcertoMensalidadeService';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import ToolbarNovo from './ToolbarNovo';
import FormDialogAcertoMensalidade from './FormDialogAcertoMensalidade';
import ProcessoService from '../../services/ProcessoService';
import AlertDialogSlide from '../share/AlertDialogSlide';
import VariantSnackbar from '../share/VariantSnackbar';
import ToolbarAcertoMensalidadeSelect from './ToolbarAcertoMensalidadeSelect';
import classnames from 'classnames';
import ClearIcon from '@material-ui/icons/Clear';
import ReplayIcon from '@material-ui/icons/Replay';
import ViewList from '@material-ui/icons/ViewList';
import Mail from '@material-ui/icons/MailOutline';
import FormDialogHistorico from './FormDialogHistorico';
import DeleteIcon from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DialogErrosDemonstrativos from './DialogErrosDemonstrativos';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    marginRight: theme.spacing.unit * 10,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  formControlAutoCompleteBenef: {
    margin: theme.spacing.unit,
    minWidth: 300,
  },
  selectOrigem: {
    margin: theme.spacing.unit,
    width: 350,
  },
  selectEstado: {
    margin: theme.spacing.unit,
    width: 250,
  },
  formControlAutoCompleteProtocolo: {
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    width: 205,
  },
  textField: {
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    width: 232,
  },
  tableRowProcessado: {
    backgroundColor: 'rgb(223, 240, 216)',
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
  tableRowAnalisado: {
    backgroundColor: '#d0edf4',
  },
  iconButton: {
    marginBottom: theme.spacing.unit,
  },
});
@inject('aplicacaoStore')
@inject('usuarioStore')
@observer

class AcertoMensalidade extends React.Component {
  acertosService = new AcertoMensalidadeService();
  processoService = new ProcessoService();
  state = {
    acertos: [],
    nomesBeneficiarios: [],
    estadoAcerto: 0,
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    fetching: false,
    fetchingInicio: true,
    origens: [],
    seqOrigemSelected: 0,
    estados: [],
    seqEstadoSelected: 0,
    protocolos: [],
    seqProtocoloSelected: 0,
    numProcessoSelected: 0,
    anoProcessoSelected: 0,
    from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    acertoSelecionado: {},
    isEditavel: true,
    modoInclusao: true,
    modoCancelamento: true,
    anosProcessos: [],
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    openDialog: false,
    openDialogValidacao: false,
    openDialogCancelamento: false,
    openDialogDesfazerCancelamento: false,
    openDialogHistorico: false,
    openDialogAnalisar: false,
    openDialogExclusao: false,
    dialogTitle: '',
    dialogContent: '',
    dialogTitleCancelamento: '',
    dialogMessageCancelamento: '',
    dialogTitleAnalisar: '',
    dialogMessageAnalisar: '',
    dialogMessageExclusao: '',
    sucesso: true,
    anchorEl: null,
    acertosSemErros: [],
  }

  componentDidMount = async () => {
    await this.consultarNomesBeneficiarios();
    await this.consultarOrigens();
    await this.consultarEstados();
    await this.consultarProtocolos();
    await this.consultarAnosProcessos();
    this.setState({fetchingInicio: false});
  }
  consultarOrigens = async () => {
    let origens = await this.props.aplicacaoStore.getOrigensAcerto();
    this.setState({ origens: origens });
  }

  consultarEstados = async () => {
    let estados = await this.props.aplicacaoStore.getEstadosAcerto();
    this.setState({ estados: estados });
  }

  consultarProtocolos = async () => {
    let protocolos = await this.props.aplicacaoStore.getProtocolosAcerto();
    this.setState({ protocolos: protocolos });
  }

  consultarNomesBeneficiarios = async () => {
    const nomesBeneficiarios = await this.props.aplicacaoStore.getBeneficiarios();
    this.setState({ nomesBeneficiarios: nomesBeneficiarios });
  }

  consultarAnosProcessos = async () => {
    let anosProcessos = await this.processoService.consultarAnosProcessos();
    this.setState({anosProcessos: anosProcessos});
  }

  handleClickBuscar = async () => {
    this.setState({acertos: [], fetching: true});
    const filtro = {
      numProtocolo: this.state.seqProtocoloSelected === undefined || this.state.seqProtocoloSelected === '' ? 0 : this.state.seqProtocoloSelected,
      numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
      codOrigem: this.state.seqOrigemSelected,
      codEstado: this.state.seqEstadoSelected,
      numProcesso: this.state.numProcessoSelected === undefined || this.state.numProcessoSelected === '' ? 0 : this.state.numProcessoSelected,
      anoProcesso: this.state.anoProcessoSelected === undefined || this.state.anoProcessoSelected === '' ? 0 : this.state.anoProcessoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
    };
    await this.consultarAcertos(filtro);
    this.setState({fetching: false});
  }
  consultarAcertos = async (filtro) => {
    this.setState({acertos: [], fetching: true});
    const acertos = await this.acertosService.consultarAcertos(filtro.numProtocolo, filtro.numMatricula, filtro.codOrigem, filtro.codEstado, filtro.numProcesso, filtro.anoProcesso, filtro.dataInicial, filtro.dataFinal);
    this.setState({ acertos: acertos, fetching: false });
  }

  handleClickLimpar = async () => {
    this.setState({
      estadoProtocolo: 0,
      carteiraSelected: '',
      nomeBeneficiarioSelected: ''
    });
  }

  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      carteiraSelected: carteira,
      nomeBeneficiarioSelected: nome
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  getSuggestionValueProtocolo = (suggestion, id) => {
    this.setState({
      seqProtocoloSelected: suggestion.nome === undefined ? suggestion : suggestion.nome,
    });
    return suggestion.nome;
  }
  handleClickIncluir = () => {
    this.setState({openDialog: true, tituloFormDialog: 'Inclusão de Acerto', acertoSelecionado: {}, modoInclusao: true, isEditavel: true});
  }
  handleDialogClose = async () => {
    await this.setState({openDialog: false});
  };
  handleDialogCloseHistorico = async () => {
    await this.setState({openDialogHistorico: false});
  };
  incluirAcerto = async (acerto) => {
    this.setState({fetching: true, acertoSelecionado: {}});
    const result = await this.acertosService.incluirAcerto(acerto);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({seqProtocoloSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({seqProtocoloSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }
  alterarAcerto = async (acerto) => {
    this.setState({fetching: true, acertoSelecionado: {}});
    const result = await this.acertosService.alterarAcerto(acerto);
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      await this.setState({seqProtocoloSelected: Number(result.data.registrosSemErros[0])});
    } else {
      await this.setState({seqProtocoloSelected: 0});
    }
    await this.onOperacaoFinalizadaIncluirAlterar(result);
  }
  analisarAcerto = async () => {
    this.setState({fetching: true});
    await this.acertosService.analisarAcerto(this.state.acertoSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Acerto analisado com sucesso!');
  }

  cancelarAcerto = async (motivoCancelamento) => {
    this.setState({fetching: true});
    await this.acertosService.cancelarAcerto(this.state.acertoSelecionado.numProtocolo, motivoCancelamento);
    await this.onOperacaoFinalizada('Acerto cancelado com sucesso!');
  }

  desfazerCancelamentoAcerto = async () => {
    this.setState({fetching: true});
    await this.acertosService.desfazerCancelamentoAcerto(this.state.acertoSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Cancelamento desfeito com sucesso!');
  }

  excluirAcerto = async () => {
    this.setState({fetching: true});
    await this.acertosService.excluirAcerto(this.state.acertoSelecionado.numProtocolo);
    await this.onOperacaoFinalizada('Acerto excluído com sucesso!');
  }

  onOperacaoFinalizada = async (msg) => {
    this.setState({fetching: false, snackOpen: true, snackMessage: msg, sucesso: true});
    const filtro = {
      numProtocolo: this.state.seqProtocoloSelected === undefined || this.state.seqProtocoloSelected === '' ? 0 : this.state.seqProtocoloSelected,
      numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
      codOrigem: this.state.seqOrigemSelected,
      codEstado: this.state.seqEstadoSelected,
      numProcesso: this.state.numProcessoSelected === undefined || this.state.numProcessoSelected === '' ? 0 : this.state.numProcessoSelected,
      anoProcesso: this.state.anoProcessoSelected === undefined || this.state.anoProcessoSelected === '' ? 0 : this.state.anoProcessoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
    };
    await this.consultarAcertos(filtro);
  }
  onOperacaoFinalizadaIncluirAlterar = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        openDialog: false,
        sucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          sucesso: true,
          fetching: false,
          openDialog: false });
        event.preventDefault();
        const filtro = {
          numProtocolo: this.state.seqProtocoloSelected === undefined || this.state.seqProtocoloSelected === '' ? 0 : this.state.seqProtocoloSelected,
          numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
          codOrigem: this.state.seqOrigemSelected,
          codEstado: this.state.seqEstadoSelected,
          numProcesso: this.state.numProcessoSelected === undefined || this.state.numProcessoSelected === '' ? 0 : this.state.numProcessoSelected,
          anoProcesso: this.state.anoProcessoSelected === undefined || this.state.anoProcessoSelected === '' ? 0 : this.state.anoProcessoSelected,
          dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
          dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
        };
        await this.consultarAcertos(filtro);
        await this.setState({seqProtocoloSelected: 0});
      } else {
        this.setState({
          openDialogValidacao: true,
          openDialog: false,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }

  onOperacaoFinalizadaSelect = async (result) => {
    if (result === undefined || result === null) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível realizar a operação.', fetching: false, sucesso: false});
    } else {
      this.setState({openDialogValidacao: true,
        dialogContent: result.registrosComErros,
        dialogTitle: result.msgRetornoResumida,
        acertosSemErros: result.registrosSemErros,
        fetching: false,
        sucesso: false});
    }
    const filtro = {
      numProtocolo: this.state.seqProtocoloSelected === undefined || this.state.seqProtocoloSelected === '' ? 0 : this.state.seqProtocoloSelected,
      numMatricula: this.state.carteiraSelected !== '' ? this.state.carteiraSelected : 'vazio',
      codOrigem: this.state.seqOrigemSelected,
      codEstado: this.state.seqEstadoSelected,
      numProcesso: this.state.numProcessoSelected === undefined || this.state.numProcessoSelected === '' ? 0 : this.state.numProcessoSelected,
      anoProcesso: this.state.anoProcessoSelected === undefined || this.state.anoProcessoSelected === '' ? 0 : this.state.anoProcessoSelected,
      dataInicial: this.state.from === '' ? parse(new Date(0)) : parse(this.state.from),
      dataFinal: this.state.to === '' ? parse(new Date(0)) : parse(this.state.to),
    };
    await this.consultarAcertos(filtro);
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };
  handleCloseDialogCancelamento = () => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false });
  };
  handleDialogConfirmCancelamento = async (motivoCancelamento) => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false, fetching: true });
    if (this.state.modoCancelamento) {
      await this.cancelarAcerto(motivoCancelamento);
    } else {
      await this.desfazerCancelamentoAcerto();
    }
  }
  handleCloseDialogAnalisar = () => {
    this.setState({ openDialogAnalisar: false });
  };
  handleDialogConfirmAnalisar = async () => {
    this.setState({ openDialogAnalisar: false, fetching: true });
    await this.analisarAcerto();
  }
  handleCloseDialogExcluir = () => {
    this.setState({ openDialogExclusao: false });
  };
  handleDialogConfirmExcluir = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirAcerto();
  }
  handleClickToolBar = () => {
    this.setState({ fetching: true });
  }
  handleClickCancelar = (event, tableMeta) => {
    const acertoSelecionado = {
      numProtocolo: this.state.acertos[tableMeta.rowIndex][0],
    };
    this.setState({openDialogCancelamento: true, dialogTitleCancelamento: 'Cancelamento de Acerto - ' + acertoSelecionado.numProtocolo, dialogMessageCancelamento: 'Deseja cancelar este Acerto? Favor informar o motivo do cancelamento:', modoCancelamento: true, acertoSelecionado: acertoSelecionado});
  }
  handleClickDesfazerCancelamento = (event, tableMeta) => {
    const acertoSelecionado = {
      numProtocolo: this.state.acertos[tableMeta.rowIndex][0],
    };
    this.setState({openDialogDesfazerCancelamento: true, dialogTitleCancelamento: 'Desfazer Cancelamento - ' + acertoSelecionado.numProtocolo, dialogMessageCancelamento: 'Deseja desfazer o cancelamento deste Acerto?', modoCancelamento: false, acertoSelecionado: acertoSelecionado});
  }
  handleClickAnalisar = (event, tableMeta) => {
    const acertoSelecionado = {
      numProtocolo: this.state.acertos[tableMeta.rowIndex][0],
    };
    this.setState({openDialogAnalisar: true, dialogTitleAnalisar: 'Marcar Acerto como analisado - ' + acertoSelecionado.numProtocolo, dialogMessageAnalisar: 'Deseja marcar este Acerto como analisado? O estado será alterado para AGUARDANDO PROCESSAMENTO', acertoSelecionado: acertoSelecionado});
  }
  handleClickMenu = (event, tableMeta) => {
    const nf = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });        
    const acertoSelecionado = {
      numProtocolo: this.state.acertos[tableMeta.rowIndex][0],
      seqBeneficiario: this.state.acertos[tableMeta.rowIndex][1],
      seqDependente: this.state.acertos[tableMeta.rowIndex][2],
      numMatricula: this.state.acertos[tableMeta.rowIndex][3],
      nomeBeneficiario: this.state.acertos[tableMeta.rowIndex][4],
      valAcerto: nf.format(this.state.acertos[tableMeta.rowIndex][5]),
      codOrigem: this.state.acertos[tableMeta.rowIndex][6],
      desOrigem: this.state.acertos[tableMeta.rowIndex][7],
      codEstado: this.state.acertos[tableMeta.rowIndex][8],
      desEstado: this.state.acertos[tableMeta.rowIndex][9],
      txtObservacao: this.state.acertos[tableMeta.rowIndex][10],
      dtaCadastro: this.state.acertos[tableMeta.rowIndex][11],
      dtaEfeitoFinanc: this.state.acertos[tableMeta.rowIndex][12],
      valPago: this.state.acertos[tableMeta.rowIndex][14] === null ? undefined : nf.format(this.state.acertos[tableMeta.rowIndex][14]),
      valCorreto: this.state.acertos[tableMeta.rowIndex][15] === null ? undefined : nf.format(this.state.acertos[tableMeta.rowIndex][15]),
      indCancelado: this.state.acertos[tableMeta.rowIndex][16],
      historicos: this.state.acertos[tableMeta.rowIndex][17],
      anoProcesso: this.state.acertos[tableMeta.rowIndex][18],
      numProcesso: this.state.acertos[tableMeta.rowIndex][19],
      desSituacao: this.state.acertos[tableMeta.rowIndex][23],
      valDiferenca: this.state.acertos[tableMeta.rowIndex][15] - this.state.acertos[tableMeta.rowIndex][14] === null ? undefined : nf.format(this.state.acertos[tableMeta.rowIndex][15] - this.state.acertos[tableMeta.rowIndex][14])
    };
    this.setState({ anchorEl: event.currentTarget, acertoSelecionado: acertoSelecionado });
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }

  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialogHistorico: true, tituloFormDialog: 'Histórico do Acerto - Protocolo ' + this.state.acertoSelecionado.numProtocolo});
    }
    if (index === 1) {
      if (this.state.acertoSelecionado.codEstado !== 3) {
        this.setState({openDialogExclusao: true, tituloFormDialog: 'Exclusão de Acerto - Protocolo ' + this.state.acertoSelecionado.numProtocolo, dialogMessageExclusao: 'Deseja excluir este acerto?'});
      } else {
        this.setState({snackOpen: true, snackMessage: 'Não foi possível excluir este Acerto pois este já foi processado.', fetching: false, sucesso: false});
      }
    }
    if (index === 2) {
      if (this.state.acertoSelecionado.codEstado === 1 || this.state.acertoSelecionado.codEstado === 2) {
        this.setState({openDialog: true, tituloFormDialog: 'Alteração de Acerto - ' + this.state.acertoSelecionado.numProtocolo, modoInclusao: false, isEditavel: true});
      } else {
        this.setState({snackOpen: true, snackMessage: 'Não foi possível alterar este Acerto pois este já foi processado ou está cancelado.', fetching: false, sucesso: false});
      }
    }
    if (index === 3) {
      this.setState({openDialog: true, tituloFormDialog: 'Visualizar Acerto - ' + this.state.acertoSelecionado.numProtocolo, modoInclusao: false, isEditavel: false});
    }
  }

  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        <ToolbarAcertoMensalidadeSelect
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          handleClickToolBar={this.handleClickToolBar}
          onOperacaoFinalizada={this.onOperacaoFinalizadaSelect}
        />
      ),
      isRowSelectable: (dataIndex) => {
        return this.state.acertos[dataIndex][8] === 2;
      },
      setRowProps: (row) => {
        return {
          title: row[8] === 3 ? 'Apenas acertos que não estejam PROCESSADOS podem ser excluídos ou alterados.' : row[8] === 2 ? 'Para processar este registro, favor selecioná-lo e clicar no botão Processar Acertos.' : '',
          className: classnames(
            {
              [this.props.classes.tableRowAnalisado]: row[8] === 2,
              [this.props.classes.tableRowProcessado]: row[8] === 3,
              [this.props.classes.tableRowCancelado]: row[8] === 4,
            }, this.props.classes.tableRow),
        };
      },

      print: false,
      download: false,
      filterType: 'dropdown',
      selectableRows: true,
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Protocolo',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Carteira',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Acerto',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'codOrigem',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Origem',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'codEstado',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Estado',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'txtObservacao',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Data Cadastro',
        options: {
          display: 'excluded',
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Data Efeito Financ.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Processo',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value === '0/0' ? '-' : <Typography>{value}</Typography>;
          },
        }
      },
      {
        name: 'valPago',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'valCorreto',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'indCancelado',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'historicos',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'anoProcesso',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'numProcesso',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Cancelamento',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              value === 'CANCELAR'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Cancelar o Acerto'}
                  onClick={event => this.handleClickCancelar(event, tableMeta)}
                >
                  <ClearIcon fontSize='default' />
                </IconButton>
                : value === 'DESFAZER'
                  ? <IconButton
                    id={'menuButton'}
                    className={classes.iconButton}
                    aria-label='More'
                    aria-owns={open ? 'long-menu' : null}
                    aria-haspopup='true'
                    title={'Desfazer o Cancelamento'}
                    onClick={event => this.handleClickDesfazerCancelamento(event, tableMeta)}
                  >
                    <ReplayIcon fontSize='default' />
                  </IconButton>
                  : '-'
            );
          },
        }
      },
      {
        name: 'Analisar',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              value === 'ANALISAR'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Alterar estado para AGUARDANDO PROCESSAMENTO'}
                  onClick={event => this.handleClickAnalisar(event, tableMeta)}
                >
                  <Mail fontSize='default' />
                </IconButton>
                : '-'
            );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <ViewList />,
                primaryText: 'Consultar Histórico...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <DeleteIcon />,
                primaryText: 'Excluir Acerto...',
                visible: true,
                disabled: false
              },
              {
                index: 2,
                icon: <Edit />,
                primaryText: 'Alterar Acerto...',
                visible: true,
                disabled: false
              },
              {
                index: 3,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Detalhes...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
      {
        name: 'desSituacao',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
    ];
    const { classes } = this.props;
    const { fetching, fetchingInicio, acertos,
      origens, seqOrigemSelected,
      estados, seqEstadoSelected,
      protocolos, numProcessoSelected, anoProcessoSelected,
      from, to } = this.state;
    return (
      <React.Fragment>
        <Link to='/financeiro' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Acertos de Mensalidade</Typography>
              <Avatar className={classes.avatar}>{acertos.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio ? <LinearProgressBlockScreen />
          : <Paper className={classes.body} elevation={1}>
            <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
              <FilterBeneficiario
                beneficiarios={this.state.nomesBeneficiarios}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} />
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectOrigem}>
                Origem
              </InputLabel>
              <Select
                className={classes.selectOrigem}
                value={seqOrigemSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'seqOrigemSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODAS</MenuItem>
                {origens.map((origem, idx) => {
                  return (<MenuItem key={idx} value={origem.id}>{origem.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectEstado}>
                Estado
              </InputLabel>
              <Select
                className={classes.selectEstado}
                value={seqEstadoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'seqEstadoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {estados.map((estado, idx) => {
                  return (<MenuItem key={idx} value={estado.id}>{estado.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl>
              <Button
                variant='extendedFab'
                title='Buscar'
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.button}>
                <Search className={classes.searchIcon} />
                Buscar
              </Button>
            </FormControl>
            <FormControl className={classes.formControlAutoCompleteProtocolo}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValueProtocolo}
                suggestions={protocolos}
                maxSuggestions={5}
                placeholder={'Digite o Protocolo...'} />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                label='Número do Processo'
                className={classes.textField}
                onChange={this.handleChange}
                value={numProcessoSelected === 0 ? '' : numProcessoSelected}
                inputProps={{
                  name: 'numProcessoSelected',
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                label='Ano do Processo'
                className={classes.textField}
                onChange={this.handleChange}
                value={anoProcessoSelected === 0 ? '' : anoProcessoSelected}
                inputProps={{
                  name: 'anoProcessoSelected',
                }}
              />
            </FormControl>
            <TextField
              id='date'
              label='De'
              type='date'
              value={from}
              onChange={this.handleChange}
              inputProps={{
                name: 'from',
              }}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id='date'
              label='Até'
              className={classes.textField}
              type='date'
              value={to}
              onChange={this.handleChange}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Paper>
        }
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={acertos}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>}
        {this.state.openDialog &&
          <FormDialogAcertoMensalidade
            titulo={this.state.tituloFormDialog}
            acerto={this.state.acertoSelecionado}
            nomesBeneficiarios={this.state.nomesBeneficiarios}
            anosProcessos={this.state.anosProcessos}
            origens={this.state.origens}
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            isEditavel={this.state.isEditavel}
            handleClose={this.handleDialogClose}
            handleSave={this.state.modoInclusao ? this.incluirAcerto : this.alterarAcerto} />}
        {this.state.openDialogHistorico &&
          <FormDialogHistorico
            titulo={this.state.tituloFormDialog}
            acerto={this.state.acertoSelecionado}
            open={this.state.openDialogHistorico}
            handleClose={this.handleDialogCloseHistorico} />}
        {this.state.openDialogCancelamento &&
        <AlertDialogSlide
          open={this.state.openDialogCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          editavel
          message={this.state.dialogMessageCancelamento} />}
        <AlertDialogSlide
          open={this.state.openDialogDesfazerCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          message={this.state.dialogMessageCancelamento} />
        <AlertDialogSlide
          open={this.state.openDialogAnalisar}
          handleClose={this.handleCloseDialogAnalisar}
          handleClick={this.handleDialogConfirmAnalisar}
          title={this.state.dialogTitleAnalisar}
          message={this.state.dialogMessageAnalisar} />
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExcluir}
          handleClick={this.handleDialogConfirmExcluir}
          title={this.state.tituloFormDialog}
          message={this.state.dialogMessageExclusao} />
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.acertosSemErros}
            nomeEntidade={'Acerto'}
            mensagemComplementar={'foi(ram) processados(s) com sucesso.'} />
        }
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AcertoMensalidade);
